import React from "react";
import { useTheme } from "styled-components";
import { Flex } from "../../Flex";
const TOP_MESSAGE_POSITION = "60px";
export const StatusMessage = ({ children, "data-testid": dataTestId }) => {
    const { colors: { tableColors }, } = useTheme();
    return (React.createElement(Flex, { alignItems: "center", "data-testid": dataTestId, backgroundColor: tableColors.statusMessageBackground, borderRadius: 1, boxShadow: "floatingBox", color: tableColors.statusMessageText, justifyContent: "center", minHeight: 4, minWidth: 1, mx: 6, px: 4, py: 2, top: TOP_MESSAGE_POSITION, width: "auto" }, children));
};
